/**
 * Genera un documento HTML completo e autocontenuto dai componenti Puck.
 *
 * Il documento include:
 *  - Google Fonts (Inter)
 *  - CSS dei componenti editoriali (puck-editor.css) in un <style> inline
 *  - Reset box-sizing e font-family di base
 *  - Markup HTML dei componenti (output di renderToStaticMarkup)
 *
 * Nota: le icone Lucide sono già rese come SVG inline da renderToStaticMarkup,
 * quindi non serve il CDN lucide.createIcons().
 *
 * In weblearner questo documento va visualizzato in un <iframe srcdoc={html} />
 * oppure tramite dangerouslySetInnerHTML (il browser processa comunque
 * <style> e <link> anche se injettati via innerHTML).
 */
export const convertToHtmlWithCss = (
  htmlInput: string,
  css?: string,
): string => {
  return `<!DOCTYPE html>
<html lang="it">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
      rel="stylesheet"
    />
    <style>
      *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
      body { font-family: 'Inter', sans-serif; }
      h1, h2, h3, h4, h5, h6 { font-size: inherit; font-weight: inherit; }
      p { margin: 0; }
      a { color: inherit; text-decoration: none; }
      img { display: block; max-width: 100%; }
      button { font-family: inherit; font-size: inherit; cursor: pointer; }
      ul, ol { list-style: none; }
      ${css ?? ""}
    </style>
    <title>Editorial</title>
  </head>
  <body>
    ${htmlInput}
  </body>
</html>`;
};
